import {
  Button,
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';

interface UnsavedChangesDrawerProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function UnsavedChangesDrawer({
  open,
  onCancel,
  onConfirm,
}: UnsavedChangesDrawerProps) {
  const { t } = useTranslation();
  return (
    <Drawer open={open} onOpenChange={onCancel} dismissible>
      <DrawerContent className="flex flex-col w-full mx-auto">
        <DrawerHeader>
          <DrawerTitle className="pb-2">
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesTitle')}
          </DrawerTitle>
          <DrawerDescription className="text-neutrals-900 wrap-break-word">
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesDescription')}
          </DrawerDescription>
        </DrawerHeader>
        <DrawerFooter>
          <Button onClick={onCancel}>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesContinue')}
          </Button>
          <Button onClick={onConfirm} variant={'outline'}>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesAbort')}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
